import { Button, CheckBox, Types } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { Controller, useFormContext } from 'react-hook-form';
import { LegalTextWithLink } from '../../molecules/LegalTextWithLink';
import { scrollToTop } from '../../utils/scrollUtils';
import { BrgModelProps, FormData } from './BrgClaimForm.types';

interface BrgControlsProps {
  agreeSubmitLabel: BrgModelProps['agreeSubmitLabel'];
  agreeSubmitErrorLabel: BrgModelProps['agreeSubmitErrorLabel'];
  submitButtonText: BrgModelProps['submitButtonText'];
  clearButtonText: BrgModelProps['clearButtonText'];
}

export function BrgFormSubmissionControls({
  agreeSubmitLabel,
  agreeSubmitErrorLabel,
  submitButtonText,
  clearButtonText,
}: BrgControlsProps) {
  const {
    control,
    formState: { isSubmitting },
    reset,
  } = useFormContext<FormData>();

  const handleClear = () => {
    reset();
    scrollToTop();
  };

  return (
    <div id="form-controls">
      <hr className="mb-5" />
      <Controller
        name="agree-checkbox"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState }) => (
          <div className="mb-4">
            <CheckBox
              className={clsx({
                'focus-error-indicator': fieldState.error,
              })}
              checkboxId="agree-checkbox"
              checkboxName="agree-checkbox"
              checked={!!field.value}
              onChange={field.onChange}
            >
              <LegalTextWithLink descriptionText={agreeSubmitLabel} innerChildClassName="m-0" />
            </CheckBox>
            {fieldState.error && <span className="t-font-xs error-text">{agreeSubmitErrorLabel}</span>}
          </div>
        )}
      />
      <div className="row">
        <Button
          className={'m-button-primary submit-button mr-4'}
          type={Types.ButtonTypeVariation.Submit}
          isDisabled={isSubmitting}
        >
          {isSubmitting ? <div className="m-spinner"></div> : submitButtonText}
        </Button>
        <Button className="m-button-secondary" type={Types.ButtonTypeVariation.Reset} callback={handleClear}>
          {clearButtonText}
        </Button>
      </div>
    </div>
  );
}
